import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosGet, axiosPost, axiosPut } from '../utils/api';

export const searchProspects = ({ q, enabled = true }) =>
  queryOptions({
    queryKey: ['/prospects/search', q],
    queryFn: async () => {
      const res = await axiosGet('/prospects/search', { params: { q } });
      return res.data;
    },
    enabled: enabled && String(q || '').trim().length >= 2,
  });

export const getProspectById = ({ id, enabled = true }) =>
  queryOptions({
    queryKey: ['/prospects', id],
    queryFn: async () => {
      const res = await axiosGet(`/prospects/${id}`);
      return res.data;
    },
    enabled: enabled && Boolean(id),
  });

export const fetchProspectById = async (id) => {
  const res = await axiosGet(`/prospects/${id}`);
  return res.data;
};

export const useCreateProspect = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ data }) => {
      const res = await axiosPost('/prospects', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/prospects/search'] });
      queryClient.invalidateQueries({ queryKey: ['/prospects'] });
    },
  });
};

export const useUpdateProspect = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }) => {
      const res = await axiosPut(`/prospects/${id}`, data);
      return res.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['/prospects/search'] });
      queryClient.invalidateQueries({ queryKey: ['/prospects', variables.id] });
    },
  });
};
